import styled from "styled-components";
import * as Card from "components/card/styles";
import zIndex from "constants/zIndex";
import queries, { devices } from "utils/responsivenessHelper";
import { fonts } from "assets/fontStyles";
import { Col, Row, styledScroll } from "components/shared/layout";

const ModalOverlay = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${zIndex.modal};
  animation: backgroundFade 0.05 ease-out;
  background: rgba(22, 42, 66, 0.5);
  backdrop-filter: blur(4px);
`;

const ModalCloseIcon = styled.img`
  position: absolute;
  top: 6.5%;
  right: 5%;
  cursor: pointer;
  height: 50px;
  width: 50px;
`;

const ModalCard = styled(Card.Container)`
  width: auto;
  position: fixed;
  top: 50%;
  left: 50%;
  right: auto;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  margin: 0;
  z-index: ${zIndex.modal};
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 100vh;

  ${queries.both(
    {
      borderRadius: 0,
      minHeight: "100vh",
      width: "100vw",
    },
    devices.phone
  )}

  ${queries.landscape(
    {
      width: "100vw",
    },
    devices.phone
  )};

  ${styledScroll};

  ::-webkit-scrollbar {
    height: 5px;
  }
  ::-webkit-scrollbar-track {
    margin: 20px 10px;
  }
`;

const StyledCol = styled(Col)`
  padding: 4em 5.625em 5em 5.625em;
  max-width: 630px;

  ${queries.both(
    {
      padding: "2em",
    },
    devices.phone
  )}
`;

const Text = styled.div`
  ${fonts.heading5};
  text-align: center;

  ${queries.both(
    {
      fontSize: "1.5rem",
    },
    devices.phone
  )}
`;

const ButtonRow = styled(Row)`
  display: flex;
  flex-direction: row;
  margin-top: 2em;
  justify-content: center;
  button {
    margin: 0.5em;
    min-width: 12em;
  }
`;

export { ModalOverlay, ModalCard, ModalCloseIcon, StyledCol, Text, ButtonRow };
